import api from '../config/api';

const API_URL = process.env.REACT_APP_API_URL;

export const fetchSetting = async name => {
  return await api
    .get(`${API_URL}Setting/getSettingsName/${name}`)
    .then(response => {
      if (response.data.data) {
        return response.data.data[0];
      }
    })

    .catch(error => {
      return error.message;
    });
};
export const fetchHorizonSettings = async type => {
  return await api
    .get(`${API_URL}Setting/getHorizonWithType/${type}`)
    .then(response => {
      if (response.data.data) {
        return response.data.data;
      }
    })

    .catch(error => {
      return error.message;
    });
};
export const updateSetting = async (id, data) => {
  return new Promise((resolve, reject) => {
    return api
      .put(`${API_URL}Setting/updateSetting/${id}`, data)
      .then(response => {
        if (response.data.data) {
          resolve(response.data.data[0]);
        }
      })
      .catch(error => {
        reject(error.message);
      });
  });
};
export const updateSettingAutoComplete = async (id, data) => {
  return new Promise((resolve, reject) => {
    return api
      .put(`${API_URL}Setting/updateSetting/${id}`, data)
      .then(response => {
        console.log('API Response:', response);
        if (response.status === 200) {
          resolve(response.data.data);
        } else {
          reject(new Error('Unexpected response status'));
        }
      })
      .catch(error => {
        console.log('API Error:', error);
        reject(error.message || 'Error updating setting');
      });
  });
};

export const fillAvailabilitiesForPeriod = async (startDate: string, endDate: string) => {
  return new Promise((resolve, reject) => {
    return api
      .post(`${API_URL}availability/fill-availabilities`, { startDate, endDate })
      .then(response => {
        if (response.data.data) {
          resolve(response.data.data);
        } else {
          reject(new Error('No data returned from API'));
        }
      })
      .catch(error => {
        reject(error.message);
      });
  });
};
